import { createContext, FC, useCallback, useContext, useMemo } from 'react';
import { createApolloClient } from 'providers/ApolloProvider';
import { QUERY_fetchPositionDetails } from 'queries';
import {
  OpenShiftPolicyEnum,
  PositionDetailsQuery,
  PositionDetailsQueryVariables,
} from 'types/graphql';

interface IFetchPositionDetailsContext {
  fetchPositionDetails: (positionId: number) => Promise<Nullable<OpenShiftPolicyEnum>>;
}

export const FetchPositionDetailsDataContext = createContext<IFetchPositionDetailsContext>(
  {} as IFetchPositionDetailsContext,
);

const client = createApolloClient();

export const FetchPositionDetailsDataProvider: FC = ({ children }) => {
  const fetchPositionDetails = useCallback(async (positionId: number): Promise<
    Nullable<OpenShiftPolicyEnum>
  > => {
    try {
      if (!positionId) return null;
      const result = await client.query<PositionDetailsQuery, PositionDetailsQueryVariables>({
        query: QUERY_fetchPositionDetails,
        variables: { positionId },
        fetchPolicy: 'network-only',
      });
      return result.data?.fetchPositions?.edges?.[0]?.node?.openShiftPolicy || null;
    } catch (error) {
      console.error('Failed to fetch position details:', error);
      return null;
    }
  }, []);

  const contextValues = useMemo(() => {
    return { fetchPositionDetails };
  }, [fetchPositionDetails]);

  return (
    <FetchPositionDetailsDataContext.Provider value={contextValues}>
      {children}
    </FetchPositionDetailsDataContext.Provider>
  );
};

export const useFetchPositionDetailsDataContext = (): IFetchPositionDetailsContext =>
  useContext(FetchPositionDetailsDataContext);
